import React from "react";
import { ListItemText } from "@mui/material";

const DSListItemText = (props: React.ComponentProps<typeof ListItemText>) => {
  return <ListItemText {...props} />;
};

export default DSListItemText;
